webpackJsonp([50],{

/***/ 532:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_page_company_integrations_vue__ = __webpack_require__(817);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_057c2621_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_company_integrations_vue__ = __webpack_require__(986);
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_page_company_integrations_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_057c2621_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_company_integrations_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 594:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _from = __webpack_require__(167);

var _from2 = _interopRequireDefault(_from);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return (0, _from2.default)(arr);
  }
};

/***/ }),

/***/ 817:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(594);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_shared_action_sidebar__ = __webpack_require__(164);




var editCompany = function () {
	var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
		var response;
		return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
			while (1) {
				switch (_context.prev = _context.next) {
					case 0:
						_context.next = 2;
						return this.loadData('project/' + this.codeProject + '/companies');

					case 2:
						response = _context.sent;

						this.model.integrations = response.records.data[0].template.data.integrations.integrations;

					case 4:
					case 'end':
						return _context.stop();
				}
			}
		}, _callee, this);
	}));

	return function editCompany() {
		return _ref.apply(this, arguments);
	};
}();

var loadIntegrations = function () {
	var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
		var response;
		return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
			while (1) {
				switch (_context2.prev = _context2.next) {
					case 0:
						_context2.prev = 0;
						_context2.next = 3;
						return this.loadData('project/' + this.codeProject + '/companies');

					case 3:
						response = _context2.sent;

						this.integrations = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(response.records.data[0].template.data.integrations.integrations));
						// console.log('INTEGRAR', this.integrations);
						_context2.next = 10;
						break;

					case 7:
						_context2.prev = 7;
						_context2.t0 = _context2['catch'](0);

						this.showNotification('El template no tiene integraciones');

					case 10:
					case 'end':
						return _context2.stop();
				}
			}
		}, _callee2, this, [[0, 7]]);
	}));

	return function loadIntegrations() {
		return _ref2.apply(this, arguments);
	};
}();

var allIntegrations = function () {
	var _ref3 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
		var url, dataResponse;
		return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
			while (1) {
				switch (_context3.prev = _context3.next) {
					case 0:
						_context3.prev = 0;
						url = 'integrations';
						_context3.next = 4;
						return this.$http.get(url);

					case 4:
						dataResponse = _context3.sent;

						this.integrationsList = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(dataResponse.data.data));
						_context3.next = 11;
						break;

					case 8:
						_context3.prev = 8;
						_context3.t0 = _context3['catch'](0);

						this.showError();

					case 11:
					case 'end':
						return _context3.stop();
				}
			}
		}, _callee3, this, [[0, 8]]);
	}));

	return function allIntegrations() {
		return _ref3.apply(this, arguments);
	};
}();

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



function created() {
	this.editCompany();
	this.loadIntegrations();
	this.allIntegrations();
}

function closeModal() {
	this.loading = true;
	this.goTo('page-company', { params: { codeProject: this.codeProject } });
	this.loading = false;
}

function sendData() {
	// const idsIntegration = this.model.integrations ?
	// 	this.model.integrations.map(integration => integration.id) : [];
	// const body = {
	// 	name: this.data.name,
	// 	integrations: idsIntegration,
	// };
	// Consumir servicio put para enviar los datos
	// Construcción de Json para pasar por el patch
	// Consumir servicio patch para editar registros
}

function data() {
	return {
		data: {},
		loading: false,
		value: true,
		model: {
			name: '',
			integrations: [],
			integrationsList: []
		},
		integrations: [],
		integrationsList: []
	};
}

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'page-company-integrations',
	created: created,
	components: {
		actionSidebar: __WEBPACK_IMPORTED_MODULE_3__components_shared_action_sidebar__["default"]
	},
	data: data,
	methods: {
		closeModal: closeModal,
		editCompany: editCompany,
		loadIntegrations: loadIntegrations,
		allIntegrations: allIntegrations,
		sendData: sendData
	},
	props: {
		codeProject: {
			type: String
		},
		codeCompany: {
			type: String
		}
	},
	watch: {
		$route: function $route(newVal) {
			if (newVal) {
				if (newVal.name === 'page-company-integrations') {
					this.loadData('project/' + this.codeProject + '/companies');
				}
			}
		}
	}
});

/***/ }),

/***/ 986:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('action-sidebar',{attrs:{"title":"Integraciones","value":_vm.value},on:{"close-modal":_vm.closeModal}},[_c('v-layout',{attrs:{"wrap":"","pa-5":""}},[_c('v-flex',{attrs:{"xs12":"","mt-5":""}},[_c('label',[_vm._v("Integraciones Agregadas")]),_vm._v(" "),_c('v-select',{staticClass:"body-1 mt-2",attrs:{"solo":"","multiple":"","box":"","chips":"","hide-details":"","disabled":true,"background-color":"white","item-text":"name","item-value":"id","label":"Integraciones","items":_vm.integrations,"return-object":""},model:{value:(_vm.model.integrations),callback:function ($$v) {_vm.$set(_vm.model, "integrations", $$v)},expression:"model.integrations"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","mt-5":""}},[_c('label',[_vm._v("Integraciones")]),_vm._v(" "),_c('v-select',{staticClass:"body-1 mt-2",attrs:{"solo":"","multiple":"","box":"","chips":"","hide-details":"","background-color":"white","item-text":"name","item-value":"id","label":"Integraciones","items":_vm.integrationsList,"return-object":""},model:{value:(_vm.model.integrationsList),callback:function ($$v) {_vm.$set(_vm.model, "integrationsList", $$v)},expression:"model.integrationsList"}})],1)],1),_vm._v(" "),_c('section',{staticClass:"modal-filter-footer"},[_c('modal-sidebar-button',{attrs:{"on-run-service":_vm.loading},on:{"cancel-button-clicked":_vm.closeModal}})],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/50.5657efc7fc8b14932d52.js